<template>
  <v-app>
    <teatro-menu v-if="showMenu"></teatro-menu>
    <v-main>
      <v-container fluid class="main-container">
        <div style="font-family: Noto Sand">
          <slot></slot>
        </div>
      </v-container>
    </v-main>
  </v-app>
</template>


<script>
import TeatroMenu from './Menu'
export default {
  name: "BasePage",
  components: {
    TeatroMenu
  },
  props: {
    showMenu: {
      type: Boolean,
      default: true
    }
  },
  data(){
    return {
      openNoti: false,
    }
  },
  methods: {
    close(){
      this.openNoti = false;
    }
  },
  watch: {
    'noti'(val){
      if (val) {
        this.openNoti = true;
      }
    }
  }
}
</script>

<style>
#app {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  font-family: var(--font-family-primary);
}

.main-container.v-container {
  padding: 0;
  max-width: 100%;
}

#content-container {
  flex-grow: 1;
  margin-bottom: var(--spacing-lg);
}
</style>